"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_RECORDS_PER_PAGE = void 0;
var DEFAULT_RECORDS_PER_PAGE = 20;
exports.DEFAULT_RECORDS_PER_PAGE = DEFAULT_RECORDS_PER_PAGE;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/gfrl/consts.js
// module id = 246
// module chunks = 0